import Vue from 'vue'
import VueRouter from 'vue-router'

const router = new VueRouter({
    routes: [
      {path: '/', redirect: '/show/index'},   
      {
        path: '/show', 
        redirect: '/show/index',
        component: () => import('@/components/ShowLayout.vue'),
        children: [
          {
            name: 'index',
            path: '/show/index', 
            component: () => import('@/pages/show/index.vue'),  // 首页
          },
          {
            name: 'space',
            path: '/show/space', 
            component: () => import('@/pages/show/space.vue'), // 极狐空间
          },
          {
            name: 'exhibition',
            path: '/show/exhibition', 
            component: () => import('@/pages/show/exhibition.vue'), // 展台信息
          },
          {
            name: 'introduce',
            path: '/show/introduce', 
            component: () => import('@/pages/show/introduce.vue'), // 车型介绍
          },
          {
            name: 'detail',
            path: '/show/detail/:id', 
            component: () => import('@/pages/show/detail.vue'), // 车型介绍详情
          },
          {
            name: 'gift',
            path: '/show/gift', 
            component: () => import('@/pages/show/gift.vue'), // 礼物
          },
          {
            name: 'more',
            path: '/show/more', 
            component: () => import('@/pages/show/more.vue'), // 更多
          },
        ]
      },
      {
        path: '/manage/login', 
        component: () => import('@/pages/manage/login.vue'),
      },
      {
        path: '/manage/list', 
        component: () => import('@/pages/manage/list.vue'),
      }
    ]
  })


export default router